// extracted by mini-css-extract-plugin
module.exports = {"control":"AddMovie_control__2ENNX","form-error":"AddMovie_form-error__3DG7I"};